import { BadgeCheck, Globe, ShieldCheck, UsersRound } from "lucide-react";
import type { AccessRoleDetailsFragment } from "@/graphql/generated/operations";
import { REGISTERED_GROUP_ID, VERIFIED_GROUP_ID } from "./access-group-labels";

export function AccessRoleIcon({ role }: { role: AccessRoleDetailsFragment }) {
  const groupIds = new Set(role.assignments.map(assignment => assignment.groupId));
  const Icon = role.code === "standard-administrators" ? ShieldCheck
    : role.code === "standard-verified" ? BadgeCheck
    : role.code === "standard-registered" ? Globe
    : groupIds.size === 1 && groupIds.has(VERIFIED_GROUP_ID) ? BadgeCheck
    : groupIds.size === 1 && groupIds.has(REGISTERED_GROUP_ID) ? Globe
    : role.permissions.some(permission => permission.code === "write:access-config") ? ShieldCheck : UsersRound;
  return <Icon className="size-4" aria-hidden="true" />;
}
